import { useResetSmartPreferences } from '@/src/hooks/srp/aiRecommendation'
import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import { useMulticityFiltersAggregate } from '@/src/hooks/srp/multicity/useMulticityFiltersAggregate'
import { useGetSearchParamsObj } from '@/src/hooks/srp/searchParams'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { DeviceType } from '@/src/types/deviceType'
import FlightNotFound from './FlightNotFound'

interface EmptyFlightScreenProps {
    deviceType: DeviceType
}

const EmptyFlightScreenWrapper = ({ deviceType }: EmptyFlightScreenProps) => {
    const { urlQueryObj } = useGetSearchParamsObj()
    const fromAirport = urlQueryObj.from || ''
    const toAirport = urlQueryObj.to || ''

    const { isMulticity } = useSearchResults()
    const { appliedFilterList } = useClearFilters()
    const { resetAIStatesAndClearAllFiltersForCurrentLeg } = useResetSmartPreferences()
    const { appliedFilterList: multicityFilterList, clearAllMulticityFilters } = useMulticityFiltersAggregate()

    const activeFilterList = isMulticity ? multicityFilterList : appliedFilterList
    const handleClearAllFilters = isMulticity
        ? clearAllMulticityFilters
        : resetAIStatesAndClearAllFiltersForCurrentLeg

    return (
        <FlightNotFound
            deviceType={deviceType}
            fromAirport={fromAirport}
            toAirport={toAirport}
            appliedFilters={activeFilterList}
            handleClearAllFilters={handleClearAllFilters}
        />
    )
}

export default EmptyFlightScreenWrapper
